'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.Moment', 'AVRO.Common.FileSave', 'AVRO.Grid.ToolbarButtons'];
module.exports = angular.module('AVRO.Grid.Toolbar', dependencies).directive('rmGridToolbar', require('./directives/GridToolbarDirective')).controller('GridToolbarController', require('./controllers/GridToolbarController'));